export var AsideModes;
(function (AsideModes) {
    AsideModes["sell"] = "sell";
    AsideModes["convert"] = "convert";
})(AsideModes || (AsideModes = {}));
